import { useSphere } from "@react-three/cannon";
import { useRef } from "react";
import { Mesh } from "three";
import { ObjectProps, Sphere, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useSphere(() => ({
    mass: 2,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0], // comment:意味ないだろw
    args: [3],
    type: 'Dynamic',
    material: {
      friction: 0.8,
      restitution: 0.6,
    },
  }), useRef<Mesh>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <Sphere args={[3]} ref={ref} castShadow receiveShadow {...bind} />
  );
};
